var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessingplant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4919 10.2559V7.2506L6.98404 10.2559H6.48321V5.74805H4.47972V10.2559H3.47793V5.74805H1.47445V10.2559H0.472656V17.2684H16V7.25077L11.4919 10.2559ZM4.98019 15.2645H2.47575V12.7601H4.98019V15.2645ZM9.98915 15.2645H7.48471V12.7601H9.98915V15.2645Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9552 1.7406C10.9552 3.40253 5.79415 4.33941 4.96297 3.10555C4.7015 3.59599 4.00809 3.79785 3.47056 3.54153C2.57919 3.1159 3.24375 3.65535 2.27995 3.65535C1.46604 3.65535 1.04626 2.76254 1.6222 2.25405C2.27466 1.67831 2.66292 2.32572 3.38505 1.90008C4.42449 1.28763 4.19215 2.2428 5.24705 1.44467C5.87076 0.972533 6.44821 1.34951 7.11712 1.04559C8.16877 0.567445 10.9551 -0.239705 10.9551 1.74061L10.9552 1.7406Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingplant);
export default __webpack_public_path__ + "static/media/processingplant.475883bea35e7505ab9adc43e25e1ca4.svg";
export { ForwardRef as ReactComponent };